import moment from 'moment';
import { toastError, toastSuccess } from '../utils/toastMessage';
import * as constants from '../constants/constants';
import { setSelectedDate } from './setDate';
import { changeDaysCount, getComplexMenus } from './menu';
import { clearPdfLink } from './menuActions';
import API from '../utils/API';
import { getComplexIdFromQueryParams, deleteQueryParameter } from '../utils/url-params';

export const selectComplex = (complex) => {
  return {
    type: constants.SELECT_COMPLEX,
    payload: {
      complex,
    },
  };
};

export const setIsShowDeletePopup = (id, name) => {
  return {
    type: constants.IS_SHOW_DELETE_POPUP,
    payload: {
      id,
      name,
    },
  };
};
export const setIsShowDeletePopupCanceled = () => {
  return {
    type: constants.IS_SHOW_DELETE_POPUP_CANCELED,
  };
};

export const toggleCreateComplexModal = () => {
  return {
    type: constants.TOGGLE_CREATE_COMPLEX_MODAL,
  };
};

export const setFoodCorseSelectedComplex = (foodCourse) => {
  return {
    type: constants.SET_FOOD_CORSE_SELECTED_COMPLEX,
    payload: {
      foodCourse,
    },
  };
};

export const getComplexesSuccess = (complexes) => {
  return {
    type: constants.GET_COMPLEXES_SUCCESS,
    payload: {
      complexes,
    },
  };
};

export const setComplexStatus = (status) => {
  return {
    type: constants.SET_COMPLEX_STATUS,
    payload: {
      status,
    },
  };
};

export const getComplexStatus = () => {
  return (dispatch) => {
    API.get(`/admin/status`)
      .then((resp) => {
        dispatch(setComplexStatus(resp.data));
      })
      .catch(() => {
        toastError('Ошибка получения статусов комплексов');
      });
  };
};

export const changeSelectedComplex = (selectedComplex) => {
  return (dispatch) => {
    if (!selectedComplex) {
      dispatch(selectComplex(null));
      deleteQueryParameter('complex');
      return;
    }
    selectedComplex.period = selectedComplex.duration;
    dispatch(selectComplex(selectedComplex));
    dispatch(changeDaysCount(selectedComplex.period));
    dispatch(getComplexMenus(selectedComplex.id));
    dispatch(clearPdfLink());
    // dispatch(getMenuGeneratorTemplates()); // TODO: CHOOSE TEMPLATES BY DAY
    dispatch(setSelectedDate(new Date(selectedComplex.startDate)));
  };
};

const transformComplexesData = (complexes) => {
  return complexes.map((complex) => {
    return {
      name: `${complex.id} ${complex.start_date ? `(${complex.start_date})` : ''} - ${
        complex.title
      }`,
      id: complex.id,
      period: complex.duration,
      startDate: complex.start_date,
      endDate: complex.end_date,
      foodCourse: complex.food_course,
      is_individual: complex.is_individual,
      ...complex,
    };
  });
};

export const getComplexes = (userId) => {
  return (dispatch) => {
    dispatch({ type: constants.GET_COMPLEXES_LOADING });
    API.get(`/users/${userId}/complexes`)
      .then((resp) => {
        const transformedComplexes = transformComplexesData(resp.data.data.complexes);
        dispatch(getComplexesSuccess(transformedComplexes));
        const complexIdFromQueryParams = getComplexIdFromQueryParams();
        if (complexIdFromQueryParams) {
          const selectedComplex = transformedComplexes.find(
            (complex) => complex.id === complexIdFromQueryParams,
          );
          dispatch(changeSelectedComplex(selectedComplex));
          return;
        }
        dispatch(changeSelectedComplex(transformedComplexes[transformedComplexes.length - 1])); // set complex by default
      })
      .catch(() => {
        dispatch({ type: constants.GET_COMPLEXES_ERROR });
        toastError('Ошибка получения комплексов пользователя');
      });
  };
};

export const changeComplexStartDate = (complexId, startDate, userId) => {
  return (dispatch) => {
    API.post(`complexes/${complexId}/edit`, {
      started_at: moment(startDate).format('YYYY-MM-DD'),
    })
      .then(() => {
        toastSuccess('Дата старта успешно назначена');
        dispatch(getComplexes(userId));
      })
      .catch(() => {
        toastError('Ошибка изменения даты старта курса');
      });
  };
};

export const changeComplexStatus = (complexId, newStatus, userId) => {
  return (dispatch) => {
    API.post(`complexes/change-status/${complexId}`, {
      status: newStatus,
    })
      .then(() => {
        toastSuccess('Статус успешно изменён');
        dispatch(getComplexes(userId));
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.msg) {
          toastError(error.response.data.msg);
          dispatch(getComplexes(userId));
        } else toastError('Ошибка изменения статуса');
      });
  };
};

export const changeComplexPauseStatus = (complexId, newStatus, userId) => {
  return (dispatch) => {
    API.post(`complexes/change-status/${complexId}`, {
      status: newStatus,
    })
      .then(() => {
        toastSuccess('Статус успешно изменён');
        dispatch(getComplexes(userId));
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.msg) {
          toastError(error.response.data.msg);
        } else toastError('Ошибка изменения статуса');
      });
  };
};

export const deleteComplex = (complexId, userId) => {
  return (dispatch) => {
    API.delete(`complexes/${complexId}`)
      .then(() => {
        toastSuccess('Комплекс курс успешно удален');
        dispatch(setIsShowDeletePopupCanceled());
        dispatch(getComplexes(userId));
      })
      .catch(() => {
        dispatch(setIsShowDeletePopupCanceled());
        toastError('Ошибка удаление комплекс курса');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/complex.js